// extracted by mini-css-extract-plugin
export var btnContainer = "toggle-text-module--btnContainer--1Ej5q";
export var navLinkFont = "toggle-text-module--navLinkFont--3tgJC";
export var dropdownIcon = "toggle-text-module--dropdownIcon--31RHu";
export var dropdownText = "toggle-text-module--dropdownText--15L6T";